import { render, staticRenderFns } from "./BaiduAttriData.vue?vue&type=template&id=2e0dcf93&scoped=true"
import script from "./BaiduAttriData.vue?vue&type=script&lang=js"
export * from "./BaiduAttriData.vue?vue&type=script&lang=js"
import style0 from "./BaiduAttriData.vue?vue&type=style&index=0&id=2e0dcf93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0dcf93",
  null
  
)

export default component.exports